import React from 'react';
import { industriesData } from '../../data/industriesData';

const IndustriesServed = () => {
  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-4xl font-bold text-catalina-blue text-center mb-4">Industries We Serve</h2>
        <p className="text-xl text-gray-600 text-center mb-12">
          Trusted by businesses across diverse sectors
        </p>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {industriesData.map((industry) => {
            const IconComponent = industry.icon;
            return (
              <div key={industry.id} className="bg-gray-50 p-8 rounded-lg text-center hover:shadow-lg transition duration-300">
                <div className="flex justify-center mb-4">
                  <IconComponent className={`w-12 h-12 text-${industry.color}`} />
                </div>
                <h3 className="text-xl font-bold text-catalina-blue mb-3">{industry.name}</h3>
                <p className="text-gray-600">{industry.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default IndustriesServed;